import { mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      items: [],
      isLoading: true,
      currentPosition: 0,
      nothingToLoad: false,
      source: null
    }
  },
  watch: {
    nothingToLoad (newVal) {
      if (newVal) {
        document.removeEventListener('scroll', this.onScroll)
      }
    }
  },
  computed: {
    ...mapState({
      stateCounter: state => state.common.header.counter
    })
  },
  methods: {
    resetLoader (summCounters) {
      this.items = []
      this.isLoading = true
      this.currentPosition = 0
      this.nothingToLoad = false

      if (summCounters) return

      this.setCounter(0)
    },
    async initLoader (fn, params = {}, groupFn, summCounters = false) {
      if (!fn) {
        throw new Error('load func not found')
      }

      const { dontSetCounter } = this
      const stringParams = JSON.stringify(params)
      this.source = stringParams

      this.resetLoader(summCounters)

      params.start = 0

      const res = await fn(params)

      // TODO переписать на cancelToken в axios
      if (stringParams !== this.source) return

      const { recordsFiltered, data } = res
      const items = groupFn ? groupFn(data) : data

      const counter = summCounters
        ? Number(this.stateCounter) + Number(recordsFiltered)
        : recordsFiltered

      if (!dontSetCounter) {
        this.setCounter(counter)
      }

      this.currentPosition = data.length

      if (data.length >= recordsFiltered) {
        this.nothingToLoad = true

        this.$bus.$emit('lazy-load-end')
      }

      this.items = items
      this.isLoading = false

      this.$nextTick(() => {
        this.$bus.$emit('tableHead-inited')
      })

      return res
    },
    async onLoad (fn, params = {}, groupFn) {
      if (this.nothingToLoad) {
        return true
      }

      this.isLoading = true

      params.start = this.currentPosition

      const res = await fn(params)
      const { recordsFiltered, data } = res

      this.currentPosition += data.length

      if (this.currentPosition >= recordsFiltered) {
        this.nothingToLoad = true

        this.$bus.$emit('lazy-load-end')
      }

      if (!groupFn) {
        this.items = this.items.concat(data)
        this.isLoading = false

        return
      }

      const { length } = this.items
      const resultItems = this.items.slice(0, -1)
      const newGroupedItems = this.items[length - 1].groupValues.concat(data)

      this.items = resultItems.concat(groupFn(newGroupedItems))
      this.isLoading = false
    },
    ...mapMutations({
      setCounter: 'SET_COUNTER'
    })
  }
}
